module.exports = __webpack_public_path__ + "img/img10.b255949b.png";